export interface IConfigFilterRequest {
    transportUnitIdVisible: boolean;
    transportUnitSizeIdVisible: boolean;
    transportUnitNumberVisible: boolean;
    stateIdVisible: boolean;
    dockIdVisible: boolean;
    turnIdVisible: boolean;
    customerIdVisible: boolean;
    terminalIdVisible: boolean;
    merchandiseTypeIdVisible: boolean;
    merchandiseOriginIdVisible: boolean;
    customsStateIdVisible: boolean;
    finalDestinationTypeIdVisible: boolean;
    organismIdVisible: boolean;
    actuationTypeGroupIdVisible: boolean;
    actuationTypeIdVisible: boolean;
    certificateTypeIdVisible: boolean;
    certificateNumberVisible: boolean;
    summaryNumberVisible: boolean;
    documentTypeIdVisible: boolean;
    invoicedVisible: boolean;
    valuedVisible: boolean;
    vuaVisible: boolean;
    alertVisible: boolean;
    appVisible: boolean;
    parkingAuthorizationVisible: boolean;
    halalCertifiedVisible: boolean;
    dryChargeVisible: boolean;
    fumigatedVisible: boolean;
    organicProductVisible: boolean;
    inspectorAssignedVisible: boolean;
    inspectorIdVisible: boolean;
    organismProfileIdVisible: boolean;
    summaryActiveVisible: boolean;
    sortVisible: boolean;
    appointmentTimeZoneVisible:boolean;
    appointmentAssigned:boolean;
    descriptionVisible: boolean;
    humanConsumptionVisible: boolean; 
    transportUnitNumberWithCertificateNumber: boolean;
    certificateNumberWithTransportUnitNumber: boolean;
}

/**
 * Schema "vacío" (todos los campos ocultos) usado como fallback cuando el backend no tiene
 * definida una vista de búsqueda de solicitudes para el rol/feature (p.ej. SuperAdmin), de forma
 * que secciones independientes del schema —como la ordenación por Nº documento— puedan renderizarse.
 */
export const emptyConfigFilterRequest = (): IConfigFilterRequest => ({
    transportUnitIdVisible: false,
    transportUnitSizeIdVisible: false,
    transportUnitNumberVisible: false,
    stateIdVisible: false,
    dockIdVisible: false,
    turnIdVisible: false,
    customerIdVisible: false,
    terminalIdVisible: false,
    merchandiseTypeIdVisible: false,
    merchandiseOriginIdVisible: false,
    customsStateIdVisible: false,
    finalDestinationTypeIdVisible: false,
    organismIdVisible: false,
    actuationTypeGroupIdVisible: false,
    actuationTypeIdVisible: false,
    certificateTypeIdVisible: false,
    certificateNumberVisible: false,
    summaryNumberVisible: false,
    documentTypeIdVisible: false,
    invoicedVisible: false,
    valuedVisible: false,
    vuaVisible: false,
    alertVisible: false,
    appVisible: false,
    parkingAuthorizationVisible: false,
    halalCertifiedVisible: false,
    dryChargeVisible: false,
    fumigatedVisible: false,
    organicProductVisible: false,
    inspectorAssignedVisible: false,
    inspectorIdVisible: false,
    organismProfileIdVisible: false,
    summaryActiveVisible: false,
    sortVisible: false,
    appointmentTimeZoneVisible: false,
    appointmentAssigned: false,
    descriptionVisible: false,
    humanConsumptionVisible: false,
    transportUnitNumberWithCertificateNumber: false,
    certificateNumberWithTransportUnitNumber: false,
});
